
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/collections/[...slug]",
      function () {
        return require("private-next-pages/[lang]/collections/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/collections/[...slug]"])
      });
    }
  